import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-increment',
  templateUrl: './increment.component.html',
  styleUrls: ['./increment.component.css']
})
export class IncrementComponent implements OnInit {

  @Input() progreso: number = 10;

  @Input('nombre') leyenda: string = 'Leyenda';

  @Output('actualizaValor') cambioValor: EventEmitter<number> = new EventEmitter();


  constructor() {
       console.log(this.leyenda);
       console.log(this.progreso);
  }

  ngOnInit(): void {
  }

  cambiarValor(valor:any){
    this.progreso = this.progreso + valor;
    this.cambioValor.emit(this.progreso);
  }

}
